import React, { useRef } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "0.5rem",
};

const center = {
  lat: 52.953328,
  lng: -1.158417,
};

interface GoogleMapEmbedProps {
  apiKey: string;
}

const GoogleMapEmbed: React.FC<GoogleMapEmbedProps> = ({ apiKey }) => {
  const mapRef = useRef<google.maps.Map | null>(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
  });

  return isLoaded ? (
    <div style={{ width: "100%", height: "100%" }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={16}
        onLoad={(map) => {
          mapRef.current = map;
        }}
      >
        <Marker position={center} title="DanСap Office" />
      </GoogleMap>
    </div>
  ) : (
    <p className="text-white">Loading map...</p>
  );
};

export default GoogleMapEmbed;
